import { render, staticRenderFns } from "./NewsPage.vue?vue&type=template&id=3fed44c8&scoped=true&"
import script from "./NewsPage.vue?vue&type=script&lang=ts&"
export * from "./NewsPage.vue?vue&type=script&lang=ts&"
import style0 from "./NewsPage.vue?vue&type=style&index=0&id=3fed44c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fed44c8",
  null
  
)

export default component.exports